import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/packages/frontend-usagers/src/layouts/default.vue").then(m => m.default || m))
}